// Copyright (c) 2016 Deere & Company

import KeyValuePairs from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import t from 'tcomb';

const WarrantyTypes = t.struct({
    allowed: t.list(KeyValuePairs, 'Allowed'),
    selected: t.list(KeyValuePairs, 'Selected')
}, 'WarrantyTypes');

export const getDefaultState = () =>
    new WarrantyTypes({
        allowed: [],
        selected: []
    });

export default WarrantyTypes;




// WEBPACK FOOTER //
// ./src/reports/warranty-expiration/state/warranty-types.js